import { useEffect, useState } from 'react';
import {
  Flex,
  Box,
  Text,
  Image,
  useDisclosure,
  SimpleGrid,
  Divider,
} from "@chakra-ui/react";
import Table from "components/table";
import Searchbar from "components/searchbar";
// import AddLocationModal from './AddLocationModal';
import { columns, sort, search } from "./data";
import CustomSelect from "components/select";
import useGetLocations from "api/queries/useGetLocations";
import { SORT_NEWEST_FIRST, SORT_OLDEST_FIRST } from "utils/constants";
import InstructionModal from "components/instructionModal";
import MainLayout from "components/mainLayout";
import ViewModal from "./ViewModal";
import Topbar from "components/topbar";
import InfoCard from "./InfoCard";
import BicesterVillageImg from "assets/bicester_village.png";

const locationsMockData = [
  { title: "Bicester Village" },
  { title: "Location No. 02" },
  { title: "Location No. 03" },
  { title: "Location No. 04" },
  { title: "Location No. 05" },
  { title: "Location No. 06" },
].map((location) => ({
  ...location,
  image: BicesterVillageImg,
  phone: "+44 123 345678",
  email: "contact@email.com",
  address: "50 Pingle Dr, Bicester OX26 6WD, UK",
  instructions: [
    "Go and drop-off your bag there.",
    "This is the point number 2.",
    "This is the point number 3.",
  ],
  mapLink: "https://www.google.com/maps",
}));

const Location = () => {
  const viewModal = useDisclosure();
  const instructionModal = useDisclosure();

  const [locations, setlocations] = useState([]);
  const [viewLocation, setViewLocation] = useState(null);
  const [sortOrder, setSortOrder] = useState(SORT_NEWEST_FIRST);
  const [searchQuery, setSearchQuery] = useState("");

  const locationsQuery = useGetLocations();

  const addActionsToRows = (rows) => {
    const dataWithActions = rows?.map((row) => {
      const action = (
        <Flex gap={2}>
          <Image
            src={require("assets/svgs/eye.svg").default}
            onClick={() => {
              setViewLocation(row);
              viewModal.onOpen();
            }}
            _hover={{ cursor: "pointer" }}
          />
        </Flex>
      );
      return {
        ...row,
        action: action,
      };
    });

    return dataWithActions;
  };

  useEffect(() => {
    const data = locationsQuery?.data?.data;
    if (!data) return;
    const searched = search(data, searchQuery);
    const sorted = sort(searched, sortOrder);
    setlocations(addActionsToRows(sorted));
  }, [searchQuery, sortOrder, locationsQuery?.data?.data]);

  return (
    <MainLayout>
      <Box h={"100%"} minH={"100vh"} paddingBottom={20}>
        <Topbar title={"DROP-off location"} />
        <Flex bg={"#f8fbff"} padding={4} height={"100%"} gap={2}>
          <Flex flex={1} direction={"column"} padding={4} gap={6}>
            <Flex justify={"space-between"} alignItems={"center"}>
              <Flex align={"center"}>
                <Searchbar onChange={setSearchQuery} title={"Search"} />
              </Flex>
              <CustomSelect
                label={"Sort"}
                onChange={setSortOrder}
                style={{ maxWidth: "200px" }}
                inputStyle={{
                  border: "none",
                  background: "#fff",
                  color: "#898989",
                  fontSize: "14px",
                  fontFamily: "PlusJakartaSansMedium",
                }}
              >
                <option value={SORT_NEWEST_FIRST}>Newest First</option>
                <option value={SORT_OLDEST_FIRST}>Oldest First</option>
              </CustomSelect>
            </Flex>
            <Divider />
            {/* <Box minW={"100%"} w={"1px"} overflowX={"auto"}>
              <SimpleGrid columns={{ base: 1, md: 2, lg: 2 }} spacing={2}>
                {locationsMockData.map((location, index) => (
                  <InfoCard
                    onClick={() => viewModal.onOpen()}
                    key={index}
                    {...location}
                  />
                ))}
              </SimpleGrid>
            </Box> */}
            <Box minW={"100%"} w={"1px"} overflowX={"auto"}>
              <Table columns={columns} data={locations} />
            </Box>
          </Flex>
        </Flex>
        {viewModal.isOpen && (
          <ViewModal
            onClose={viewModal.onClose}
            isOpen={viewModal.isOpen}
            location={viewLocation}
          />
        )}
        <InstructionModal
          isOpen={instructionModal.isOpen}
          onClose={instructionModal.onClose}
        />
      </Box>
    </MainLayout>
  );
};

export default Location;